import { api } from '../api';
import type { CompanySettings, UpdateSettingsData } from '../../../modules/settings/types/settingsTypes';

export const settingsService = {
  get: async (tenantTypeId: string) => {
    const response = await api.get<CompanySettings>(`tenant-types/${tenantTypeId}`);
    console.log('SettingsService - Resposta da API:', JSON.stringify(response.data, null, 2));
    return response;
  },
  update: (data: UpdateSettingsData, tenantTypeId: string) => {
    console.log('SettingsService - Dados recebidos:', JSON.stringify(data, null, 2));
    console.log('SettingsService - TenantTypeId:', tenantTypeId);
    
    // Garantir que os dados sejam serializados corretamente
    const serializedData = JSON.parse(JSON.stringify(data));
    
    console.log('SettingsService - Dados serializados:', JSON.stringify(serializedData, null, 2));
    
    return api.patch(`tenant-types/${tenantTypeId}`, serializedData);
  },
}; 